import React, { memo } from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Dream It',
  description: 'Share your ideas and inspiration.',
  color: 'text-[#FF83B4]'
}, {
  number: '02',
  title: 'Design It',
  description: "We create a party that's uniquely yours.",
  color: 'text-[#F79C6F]'
}, {
  number: '03',
  title: 'Prepare It',
  description: 'We take care of all the details.',
  color: 'text-[#75D5EA]'
}, {
  number: '04',
  title: 'Enjoy It',
  description: 'Show up, celebrate, and make memories. ✨',
  color: 'text-[#FCD06D]'
}];
export function Process() {
  return <section id="process" className="py-24 md:py-28 bg-soft-cream relative overflow-hidden" data-id="element-145" data-mp="1fo79a2kulqbq">
      
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-146" data-mp="1kfyzud407w1v">
        <div className="text-center mb-16" data-id="element-147" data-mp="n01ojftso1bw">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl text-soft-terracotta mb-6 font-normal font-[Merriweather,_serif]" data-id="element-148" data-mp="mz0f1fsffmwa">
            
            How It <span className="italic font-light" data-id="element-149" data-mp="15kxcs1jm0jr4">Works</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-soft-dark text-base md:text-lg max-w-2xl mx-auto font-light font-[Avenir,_sans-serif]" data-id="element-150" data-mp="10s49li3shjh5">
            
            From the first idea to party day, we take care of every detail so
            you can relax, be present, and enjoy the celebration with your loved
            ones. Our goal is to create a beautiful, stress free experience
            focused on making memories.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-14 relative" data-id="element-151" data-mp="2c5q6jpfw4pd8">
          {/* Desktop hairline connector — centered to the number band */}
          <div className="hidden md:block absolute top-10 left-[12%] right-[12%] h-px bg-soft-terracotta/20 z-0" data-id="element-152" data-mp="2qcbh7kvk1959" />

          {steps.map((step, index) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.6
        }} className="relative z-10 flex flex-col items-start" data-id="element-153" data-mp="2hd6ee2cymtna" data-mpi={index}>
            
              {/* Fixed-height number band so the connector lines up across all steps */}
              <div className="h-20 flex items-center mb-6" data-id="element-154" data-mp="302w8soct9deo">
                <span className={`text-7xl md:text-8xl leading-none font-[Merriweather,_serif] font-light tracking-tighter opacity-30 ${step.color}`} data-id="element-155" data-mp="351zemb0m7nnp">
                
                  {step.number}
                </span>
              </div>
              <h3 className="text-2xl text-soft-terracotta mb-2 font-normal font-[Merriweather,_serif]" data-id="element-156" data-mp="1ton9zxx1710h">
                {step.title}
              </h3>
              <p className="text-soft-dark font-light pr-6 font-[Avenir,_sans-serif] text-[16px]" data-id="element-157" data-mp="1h59jccfsm3k5">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}